/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SidebarSimpleItem.vue?vue&type=template&id=2a866a18"
import script from "./SidebarSimpleItem.vue?vue&type=script&lang=js"
export * from "./SidebarSimpleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports